'use strict';

var React = require('react'),
    Alert = require('../organisms/Alert'),
    Button = require('../atoms/Button'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var OkayAlert = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    title: PropTypes.string.isRequired,
    message: PropTypes.node,
    buttonText: PropTypes.string.isRequired
  },

  getDefaultProps() {
    return {
      buttonText: 'Okay'
    };
  },

  render() {
    var { title, message, buttonText } = this.props;

    return (
      <Alert title={title}
             message={message}>
        <Button size='large'
                onClick={this.handleHideClick}>
          {buttonText}
        </Button>
      </Alert>
    );
  },

  handleHideClick() {
    AlertActionCreators.hideAlert();
  }
});

module.exports = OkayAlert;


/** WEBPACK FOOTER **
 ** ./alerts/OkayAlert.jsx
 **/